import type { OrderEditingRequest } from './order-editing';

export type MerchantRequestType = 'ISSUE' | 'RETURN' | 'ORDER_EDITING';
export type MerchantRequestGroup = 'NEEDS_ACTION' | 'WAITING' | 'CLOSED';

export interface MerchantRequest {
  id: string;
  type: MerchantRequestType;
  number: string;
  orderId: string;
  shopifyOrderId?: string | null;
  orderNumber?: string | null;
  customerName?: string | null;
  customerEmail?: string | null;
  status: string;
  statusLabel: string;
  outcome?: string | null;
  requestedResolution?: string | null;
  group: MerchantRequestGroup;
  nextAction: string;
  nextActionLabel: string;
  responsibleParty?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  dueAt?: string | null;
  settlementStatus?: string | null;
  settlementType?: string | null;
  summary?: string | null;
  orderEditingRequest?: OrderEditingRequest | null;
  items: Array<{
    orderItemId?: string | null;
    title?: string | null;
    quantity?: number | null;
    reason?: string | null;
    requestedResolution?: string | null;
    resolution?: string | null;
  }>;
}

export interface MerchantRequestsQueryResult {
  merchantRequests?: {
    storeId: string;
    totalCount: number;
    limit: number;
    offset: number;
    hasMore: boolean;
    counts: Array<{ group: MerchantRequestGroup | 'ALL'; count: number }>;
    nodes: MerchantRequest[];
  } | null;
}

export const canManageRequests = (role?: string, shipaidAdmin = false) =>
  shipaidAdmin ||
  role === 'ADMIN' ||
  role === 'MANAGER' ||
  role === 'shipaid_admin';
